<template>
    <RingBottomNavigation :options="options" v-model="selected" borderColor="#275D93"
        style="right: 0; width: inherit; position:inherit; bottom: 0; margin: 0; padding: 0; background-color: white;">
        <template #icon="{ props }">
            <div class="icon-container">
                <font-awesome-icon :icon="props.icon" :style="{ color: getIconColor(props) }"></font-awesome-icon>
                <span v-if="props.id === 2 && !loading && transaction_total > 0" class="notification-badge">
                    {{ transaction_total }}
                </span>
            </div>
        </template>
        <template #title="{ props }">
            <span :style="{ color: getIconColor(props) }">{{ props.title }}</span>
        </template>
    </RingBottomNavigation>
</template>

<script>
import TransactionService from "@/services/transaction.service";

export default {
    name: 'BottomBar',
    data() {
        return {
            //check current url
            selected: this.page ?? 1,
            options: [
                {
                    id: 1,
                    icon: 'home',
                    title: this.$t('Home'),
                    path: '/'
                },
                {
                    id: 2,
                    icon: 'receipt',
                    title: this.$t('Transaction'),
                    path: '/transaction'
                },
                // {
                //     id: 3,
                //     icon: 'comment-dots',
                //     title: this.$t('Open Ticket'),
                //     path: '/ticket'
                // },
                {
                    id: 4,
                    icon: 'user',
                    title: this.$t('Profile'),
                    path: '/profile'
                }
            ],

            transaction_total: 0,
        };
    },
    computed: {
        currentUser() {
            return localStorage.getItem('loggedData') ? JSON.parse(localStorage.getItem('loggedData')).user : null;
        },
    },
    components: {
        //
    },
    props: {
        page: {
            type: String,
            required: true
        },
        loading: {
            type: Boolean,
            default: false,
        }
    },
    methods: {
        getIconColor(props) {
            return props.selected ? '#275D93' : '#6c757d';
        },

        loadTransactions() {
            if (this.currentUser) {
                TransactionService.getNotificationCountByUserId(this.currentUser.id, 'PAYMENT')
                    .then((response) => {
                        if (response.data.status == "success") {
                            this.transaction_total = response.data.data;
                        } else {
                            this.transaction_total = 0;
                        }
                    })
                    .catch((error) => {
                        if (error.response) {
                            if (error.response.status == 401) {
                                this.$store.dispatch("auth/logout");
                                this.$router.push('/login');
                                return; // Exit the function after handling 401
                            }
                        }
                    });
            } else {
                this.transaction_total = 0;
            }
        }
    },
    watch: {
        loading() {
            this.loadTransactions();
        },
    }
};
</script>

<style scoped>
.icon-container {
    position: relative;
    display: inline-block;
}

.notification-badge {
    background-color: red;
    border-radius: 50%;
    width: 16px;
    height: 16px;
    position: absolute;
    top: 0;
    right: 0;
    margin-right: -12px;
    margin-top: -3px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 9px;
    color: white;
}
</style>